import { render, staticRenderFns } from "./goods-offer.vue?vue&type=template&id=923b1d50&scoped=true&"
import script from "./goods-offer.vue?vue&type=script&lang=js&"
export * from "./goods-offer.vue?vue&type=script&lang=js&"
import style0 from "./goods-offer.vue?vue&type=style&index=0&id=923b1d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923b1d50",
  null
  
)

export default component.exports